import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatTabChangeEvent as MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { ClientService } from '../client.service';
import { ClientDownload, DownloadData, DownloadLink } from '../models';

const __IMGSIGNER = 0;
const indexToPathMapping: { [key: number]: string } = { 0: "/products/imgsigner", 1: "/products/dotnet", 2: "/products/nodejs", 3: "/products/python" };
const pathToIndexMapping: { [key: string]: number } = { "/products/imgsigner": 0, "/products/dotnet": 1, "/products/nodejs": 2, "/products/python": 3 };

@Component({
  selector: 'app-downloads',
  standalone: false,
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent implements OnInit {
  public clients: ClientDownload[] = [];
  public selectedIndex: number = 0;
  public loading: boolean = true;

  constructor(private router: Router, private clientSvc: ClientService, private cdr: ChangeDetectorRef) {}

  async ngOnInit() {
    this.loading = true;
    await this.loadAllClientData();
    this.loading = false;

    let initialIndex = pathToIndexMapping[this.router.url];
    if (initialIndex === undefined) {
      initialIndex = __IMGSIGNER;
    }
    this.changeTabs(initialIndex);
    this.cdr.detectChanges();
  }

  async loadAllClientData() {
    try {
      const dataPromises = [
        this.clientSvc.getClientDownloads('imgsigner'),
        this.clientSvc.getClientVersion('imgsigner'),
        this.clientSvc.getClientDownloads('dotnet'),
        this.clientSvc.getClientVersion('dotnet'),
        this.clientSvc.getClientDownloads('nodejs'),
        this.clientSvc.getClientVersion('nodejs'),
        this.clientSvc.getClientDownloads('python'),
        this.clientSvc.getClientVersion('python')
      ] as const;

      const results = await Promise.all(dataPromises);
      const processDownloads = (res: any): DownloadData => {
        if (typeof res === 'boolean' || !res.paths) {
          return { latest: null, prior: [] };
        }

        const downloads: DownloadLink[] = res.paths.map((item: string) => ({
          name: item.split('/').pop() || '',
          url: `/${item}`
        }));

        downloads.sort((a, b) => b.name.localeCompare(a.name));

        return {
          latest: downloads[0] || null,
          prior: downloads.slice(1)
        };
      };

      this.clients = [
        { language: 'ImgSigner Application', download: processDownloads(results[0]), latest: { version: (typeof results[1] === 'object' && results[1] !== null) ? results[1].version : 'N/A' } },
        { language: '.NET Library',          download: processDownloads(results[2]), latest: { version: (typeof results[3] === 'object' && results[3] !== null) ? results[3].version : 'N/A' } },
        { language: 'Node.js Library',       download: processDownloads(results[4]), latest: { version: (typeof results[5] === 'object' && results[5] !== null) ? results[5].version : 'N/A' } },
        { language: 'Python Library',        download: processDownloads(results[6]), latest: { version: (typeof results[7] === 'object' && results[7] !== null) ? results[7].version : 'N/A' } }
      ];

    } catch (error) {
      console.error("Failed to load all client data:", error);
      this.loading = false;
    }
  }

  selectedTabChange(event: MatTabChangeEvent): void {
    this.changeTabs(event.index);
  }

  changeTabs(index: number): void {
    this.selectedIndex = index;
    const path = indexToPathMapping[index];
    if (path) {
      this.router.navigate([path]);
    }
  }
}
